import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectsWrapper } from './styles';

const Wrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { t } = useTranslation();
    return <SelectsWrapper>{children}</SelectsWrapper>;
};

export default Wrapper;
